/**
 * Convert a persisted topology definition into builder nodes/edges, so the
 * design canvas can load an existing topology for editing. The inverse of
 * `flowToTopology`; positions come from the shared `layoutNodes`.
 */

import type { Node, Edge } from "@xyflow/react";
import { layoutNodes } from "./topology-layout.js";

export function topologyToBuilder(definition: any): { nodes: Node[]; edges: Edge[] } {
  const def = definition ?? {};
  const agentDefs: any[] = def.agents ?? [];
  const { positions, orientation } = layoutNodes(agentDefs, def);
  const exitSet = new Set<string>(def.exitPoints ?? []);

  const nodes: Node[] = agentDefs.map((a) => ({
    id: a.id,
    type: "agent",
    position: positions.get(a.id) ?? { x: 0, y: 0 },
    data: {
      label: a.name ?? a.id,
      name: a.name ?? a.id,
      agentId: a.id,
      backend: a.backend ?? "claude-agent-sdk",
      model: a.model,
      status: "idle",
      description: a.description ?? "",
      identity: a.identity ?? { persona: "", instructions: "" },
      capabilities: a.capabilities ?? [],
      security: a.security,
      isEntryPoint: a.id === def.entryPoint,
      isExitPoint: exitSet.has(a.id),
      orientation,
    },
  }));

  let edgeSeq = 0;
  const edges: Edge[] = (def.edges ?? []).map((e: any) => ({
    id: `edge-${++edgeSeq}`,
    source: e.from,
    target: e.to,
    type: "custom",
    data: { edgeType: e.type ?? "delegates-to", bidirectional: e.bidirectional ?? false },
  }));

  return { nodes, edges };
}
